import React from "react";
import { Grid, CardActions, Card, CardMedia, CardContent } from "@material-ui/core";
import styled from "styled-components";
import getUrl from "../../functions/getUrl";
import { H3 } from "../Headers";
import BlockQuote from "../BlockQuote";
import LinkButton from "../LinkButton";
import { RouteComponentProps, withRouter } from "react-router";
import { ApplicationPaths } from "../api-authorization/ApiAuthorizationConstants";

const SignupGrid = styled(Grid)`
  width: 100%;
`;

const Title = styled(H3)`
  margin-top: 10px;
  font-size: 18px;
  font-weight: 800;
`;

const CardImg = styled(CardMedia)`
  height: 140px;
`;

const StyledCard = styled(Card)<{ maxwidth?: string }>`
  max-width: ${({ maxwidth }) => maxwidth || "400px"};
`;

const ActionContainer = styled.div`
  max-width: 300px;
  margin: 0 auto 2em auto;
`;

export interface ISignUpCardProps extends RouteComponentProps {
  image: string;
  imageTitle: string;
  title: string;
  cardMaxWidth?: string;
}

const SignUpCard = (props: ISignUpCardProps) => {
  return (
    <SignupGrid container justify="center" alignItems="center">
      <Grid item>
        <StyledCard maxwidth={props.cardMaxWidth}>
          <Title center>Apply or Log In</Title>
          <CardImg image={getUrl(props.image)} title={props.title} />
          <CardContent>
            <BlockQuote>
              <p>Apply or log in to access everything you need to build and maintain your Skyward API Integration.</p>
            </BlockQuote>
          </CardContent>
          <CardActions>
            <ActionContainer>
              <LinkButton to="/apply">Apply</LinkButton>
              <LinkButton to={ApplicationPaths.Login}>Log In</LinkButton>
            </ActionContainer>
          </CardActions>
        </StyledCard>
      </Grid>
    </SignupGrid>
  );
};

export default withRouter(SignUpCard);
